var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w80pct mc"},[_c('Confirm',{ref:"Confirm",attrs:{"cancelBtn":false,"title":'',"size":'l'}}),_vm._v(" "),_c('div',{staticClass:"tableSys mt3x mb4x"},[_c('div',{staticClass:"vaB_E dpIB_E"},[_c('img',{staticClass:"w15x",attrs:{"src":_vm.stage.loc.logo.login[_vm.stage.languageId]
						? _vm.stage.loc.logo.login[_vm.stage.languageId]
						: _vm.stage.loc.logo.login.public}}),_vm._v(" "),_vm._l((_vm.btnGroup),function(item,index){return (_vm.stage.setting.loc['2in1'].file)?_c('button',{key:index,staticClass:"fs16x ml2x pl1x",class:{ cSub: index != _vm.currentIndex },attrs:{"name":index + ' ' + _vm.currentIndex},on:{"click":function($event){return _vm.changeBtn(index, 'currentIndex')}}},[_vm._v("\n\t\t\t\t"+_vm._s(item.title)+"\n\t\t\t")]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"taR",staticStyle:{"width":"65px"}},[_c('Select',{attrs:{"styleType":'noBorder',"list":_vm.stage.languageList,"bindActive":_vm.stage.languageId},on:{"Click":function (i) {
						_vm.setLanguage(_vm.stage.languageList[i].value);
					}}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentIndex == 0),expression:"currentIndex == 0"}],staticClass:"select-content"},[_c('div',{staticClass:"bg-mask",style:({
				'background-image': ("url(" + (_vm.stage.setting.loc['2in1'].cover.c) + ")"),
			})},[_c('div',{staticClass:"wrap-mask tra-fast"}),_vm._v(" "),_c('a',{staticClass:"content tra-fast",attrs:{"href":_vm.stage.type.c},on:{"click":function($event){return _vm.setCookie('type', 'c')}}},[_c('h3',{staticClass:"fs20x"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t("platformSelect1", [
							_vm.stage.loc.customerDisplay[_vm.stage.languageId] ||
								_vm.stage.loc.customerDisplay.public,
							"CSI Cloud用户版平台" ]))+"\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"fs14x"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t("platformSelect2", [
							_vm.stage.loc.customerDisplay[_vm.stage.languageId] ||
								_vm.stage.loc.customerDisplay.public,
							"专为光伏电站用户而设计。实现光伏电站运行情况和发电收益数据的全天候监控，保障用户财产安全。" ]))+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"fs12x fWhite hover-c-white"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t("platformSelect3", [
							_vm.stage.loc.customerDisplay[_vm.stage.languageId] ||
								_vm.stage.loc.customerDisplay.public,
							"前往 CSI CloudPro" ]))),_c('Icon',{staticClass:"ico w1x h1x ml1x",attrs:{"name":"more"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"bg-mask ml1x",style:({
				'background-image': ("url(" + (_vm.stage.setting.loc['2in1'].cover.b) + ")"),
			})},[_c('div',{staticClass:"wrap-mask tra-fast"}),_vm._v(" "),_c('a',{staticClass:"content tra-fast",attrs:{"href":_vm.stage.type.b},on:{"click":function($event){return _vm.setCookie('type', 'b')}}},[_c('h3',{staticClass:"fs20x"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t("platformSelect4", [
							_vm.stage.loc.customerDisplay[_vm.stage.languageId] ||
								_vm.stage.loc.customerDisplay.public,
							"CSI CloudPro商家版平台" ]))+"\n\t\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"fs14x"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t("platformSelect5", [
							_vm.stage.loc.customerDisplay[_vm.stage.languageId] ||
								_vm.stage.loc.customerDisplay.public,
							"专为在电站生命周期中提供各种服务的商家而设计。我们为不同的服务内容提供了不同的业务板块来满足商家复杂的业务场景和需求，从而保障用户的电站发电收益和安全。" ]))+"\n\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"fs12x fWhite hover-c-white"},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.$t("platformSelect6", [
							_vm.stage.loc.customerDisplay[_vm.stage.languageId] ||
								_vm.stage.loc.customerDisplay.public,
							"前往 CSI CloudPro" ]))),_c('Icon',{staticClass:"ico w1x h1x ml1x",attrs:{"name":"more"}})],1)])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentIndex == 1 && _vm.stage.setting.loc['2in1'].file),expression:"currentIndex == 1 && stage.setting.loc['2in1'].file"}],attrs:{"id":"downloadPanel"}},[_c('aside',{staticClass:"sideSys tra noSelect"},[_c('div',{staticClass:"scrollHide",attrs:{"scroll":""}},[_c('nav',[_c('div',{staticClass:"menuList tra tra-fast_E"},_vm._l((_vm.btnGroup_sideBar),function(item,index){return _c('a',{key:index,staticClass:"fs12x",class:{
								'cSub-imp': index != _vm.currentIndex_sideBar,
							},on:{"click":function($event){return _vm.changeBtn(index, 'currentIndex_sideBar')}}},[_vm._v(_vm._s(item.title))])}),0)])])]),_vm._v(" "),_c('section',{staticClass:"downloadSection"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentIndex_sideBar == 0),expression:"currentIndex_sideBar == 0"}],staticClass:"pl2x"},[_c('ul',{staticClass:"mt3x_E"},[_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s((_vm.stage.loc.customerDisplay[
									_vm.stage.languageId
								] || _vm.stage.loc.customerDisplay.public) +
								_vm.getLanguageStr(
									" Web+word1814",
									"CSI Cloud Web使用说明文档"
								))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.c.web[
											_vm.stage.languageId
									  ][0] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.stage.loc.customerDisplay +
								_vm.getLanguageStr(
									' Web+word1814',
									'CSI Cloud Web使用说明文档'
								)}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s((_vm.stage.loc.customerDisplay[
									_vm.stage.languageId
								] || _vm.stage.loc.customerDisplay.public) +
								_vm.getLanguageStr(
									" APP+word1814",
									"CSI Cloud APP使用说明文档"
								))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.c.app[
											_vm.stage.languageId
									  ][0] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.stage.loc.customerDisplay +
								_vm.getLanguageStr(
									' APP+word1814',
									'CSI Cloud APP使用说明文档'
								)}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.getLanguageStr(
									"CSI Cloud Q&A",
									"CSI Cloud Q&A"
								))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.c.qa[
											_vm.stage.languageId
									  ] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.getLanguageStr(
									'CSI Cloud Q&A.' +
										_vm.getFileType(
											_vm.stage.setting.loc['2in1'].file.c
												.qa[_vm.stage.languageId]
										),
									'CSI Cloud Q&A'
								)}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentIndex_sideBar == 1),expression:"currentIndex_sideBar == 1"}],staticClass:"pl2x"},[_c('ul',{staticClass:"mt3x_E"},[_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s((_vm.stage.loc.customerDisplay[
									_vm.stage.languageId
								] || _vm.stage.loc.customerDisplay.public) +
								_vm.getLanguageStr(
									"Pro Web+word1814",
									"CSI CloudPro Web使用说明文档"
								))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.b.web[
											_vm.stage.languageId
									  ][1] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.stage.loc.customerDisplay +
								_vm.getLanguageStr(
									'Pro Web+word1814',
									'CSI CloudPro Web使用说明文档'
								)}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s((_vm.stage.loc.customerDisplay[
									_vm.stage.languageId
								] || _vm.stage.loc.customerDisplay.public) +
								_vm.getLanguageStr(
									"Pro APP+word1814",
									"CSI CloudPro APP使用说明文档"
								))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.b.app[
											_vm.stage.languageId
									  ][1] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.stage.loc.customerDisplay +
								_vm.getLanguageStr(
									'Pro APP+word1814',
									'CSI CloudPro APP使用说明文档'
								)}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s((_vm.stage.loc.customerDisplay[
									_vm.stage.languageId
								] || _vm.stage.loc.customerDisplay.public) +
								_vm.getLanguageStr(
									"Pro Web+word1814",
									"CSI CloudPro Web使用说明文档"
								))+"\n\t\t\t\t\t\t\t("+_vm._s(_vm.getLanguageStr("word1816", "完整版"))+")\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.b.web[
											_vm.stage.languageId
									  ][0] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.stage.loc.customerDisplay +
								_vm.getLanguageStr(
									'Pro Web+word1814',
									'CSI CloudPro Web使用说明文档'
								) +
								'(' +
								_vm.getLanguageStr('word1816', '完整版') +
								')'}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s((_vm.stage.loc.customerDisplay[
									_vm.stage.languageId
								] || _vm.stage.loc.customerDisplay.public) +
								_vm.getLanguageStr(
									"Pro APP+word1814",
									"CSI CloudPro APP使用说明文档"
								))+"\n\t\t\t\t\t\t\t("+_vm._s(_vm.getLanguageStr("word1816", "完整版"))+")\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.b.app[
											_vm.stage.languageId
									  ][0] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.stage.loc.customerDisplay +
								_vm.getLanguageStr(
									'Pro APP+word1814',
									'CSI CloudPro APP使用说明文档'
								) +
								'(' +
								_vm.getLanguageStr('word1816', '完整版') +
								')'}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"fs12x"},[_vm._v("\n\t\t\t\t\t\t\t"+_vm._s(_vm.getLanguageStr(
									"CSI CloudPro Q&A",
									"CSI CloudPro Q&A"
								))+"\n\t\t\t\t\t\t")]),_vm._v(" "),_c('a',{staticClass:"dpIB functionBtn sizeM lh25 hover-c-white",attrs:{"href":_vm.stage.setting.loc['2in1'].file
									? _vm.stage.setting.loc['2in1'].file.b.qa[
											_vm.stage.languageId
									  ] +
									  '?' +
									  _vm.stage.ver
									: '',"download":_vm.getLanguageStr(
									'CSI CloudPro Q&A.' +
										_vm.getFileType(
											_vm.stage.setting.loc['2in1'].file.b
												.qa[_vm.stage.languageId]
										),
									'CSI CloudPro Q&A.docx'
								)}},[_vm._v(_vm._s(_vm.getLanguageStr("cmd281", "点击这里下载")))])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bed6cce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/frame/PlatformSelect.vue
// module id = null
// module chunks = 